type TwilioVoiceCall = {
  customParameters?: { get?: (key: string) => string | undefined } & Record<string, string | undefined>;
  parameters?: Record<string, string | undefined>;
};

export type InternalIncomingCallMeta = {
  isInternal: boolean;
  callerDisplayName: string | null;
  callerCompanyName: string | null;
  callCompanyId: string | null;
};

const readCallParam = (call: TwilioVoiceCall | null | undefined, ...keys: string[]): string | null => {
  if (!call) return null;

  const custom = call.customParameters as any;
  const params = call.parameters;

  for (const key of keys) {
    const fromMap = typeof custom?.get === "function" ? custom.get(key) : undefined;
    const directVal = (fromMap ?? custom?.[key] ?? params?.[key] ?? "").toString().trim();
    if (directVal) return directVal;

    // Búsqueda case-insensitive automática si no hubo coincidencia exacta
    const lowerKey = key.toLowerCase();
    if (custom && typeof custom.forEach === "function") {
      let matched: string | null = null;
      custom.forEach((v: any, k: string) => {
        if (!matched && k.toLowerCase() === lowerKey && v) {
          matched = String(v).trim();
        }
      });
      if (matched) return matched;
    } else if (custom && typeof custom === "object") {
      for (const [k, v] of Object.entries(custom)) {
        if (k.toLowerCase() === lowerKey && v) return String(v).trim();
      }
    }

    if (params && typeof params === "object") {
      for (const [k, v] of Object.entries(params)) {
        if (k.toLowerCase() === lowerKey && v) return String(v).trim();
      }
    }
  }

  return null;
};

const formatInternalCallerName = (name?: string | null, companyName?: string | null): string | null => {
  const person = name?.trim();
  const company = companyName?.trim();
  if (person && company) return `${company} - ${person}`;
  return person || company || null;
};

export const readInternalIncomingCall = (call: TwilioVoiceCall | null | undefined): InternalIncomingCallMeta => {
  const internalFlag = readCallParam(call, "internalCall");
  const callerName = readCallParam(call, "callerName");
  const callerCompanyName = readCallParam(call, "callerCompanyName", "companyName");
  const callerDisplayName =
    readCallParam(call, "callerDisplayName") || formatInternalCallerName(callerName, callerCompanyName);
  const callCompanyId = readCallParam(call, "companyId");

  const from = (call?.parameters?.From ?? "").toString();
  const looksLikeClientIdentity = from.startsWith("client:");

  return {
    isInternal: internalFlag === "1" || looksLikeClientIdentity,
    callerDisplayName,
    callerCompanyName,
    callCompanyId,
  };
};
